import * as React from 'react';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import Button from '../../zeon-react-ui/button/Button';

import { useAuth } from '../../zeon-react-ui/auth/model';
import { DMDisplayGrid } from './displaygrid';
import SiteSelect from './sites';
import ParamSelect from './params';

const _ACL_LEVEL_ = "L_DA_DISP_AGE_R";

const DisMag = () => {
  const nowCollection = `W${`${new Date(Date.now()).getFullYear()}`.substr(2)}${`${new Date(Date.now()).getFullYear() + 1}`.substr(2)}`;
  const auth = useAuth();

  const [DisMagSite, setDisMagSite] = React.useState(`${auth.appdata && auth.appdata["ifs"] ? auth.appdata["ifs"]["defaults"]["site"] : ""}`);
  const [DisMagLocation, setDisMagLocation] = React.useState(`${auth.appdata && auth.appdata["ifs"] ? auth.appdata["ifs"]["defaults"]["location"] : ""}`);
  const [DisMagCollection, setDisMagCollection] = React.useState(nowCollection);
  const [DisMagCommodity, setDisMagCommodity] = React.useState(`${auth.appdata && auth.appdata["ifs"] ? auth.appdata["ifs"]["defaults"]["commodity"] : ""}`);
  const [DisMagSku, setDisMagSku] = React.useState("");
  const [DisMagTiming, setDisMagTiming] = React.useState(false);
  const [DisMagQuantity, setDisMagQuantity] = React.useState(false);

  const [loading, setLoading] = React.useState(false);
  const [sitesLoaded, setSitesLoaded] = React.useState(false);
  const [paramsLoaded, setParamsLoaded] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);
  const [error, setError] = React.useState("");
  const loadingCircle = <Container sx={{ mt: 5, width: "80px" }}><CircularProgress /></Container>
  const errorAlert = <Alert severity="error">{error}</Alert>
  const [payload, setPayload] = React.useState({
    ifs_time: 0,
    njs_time: 0,
    params: {
      site: "",
      location: "",
      collection: "",
      commodity: "",
      timing: false,
      quantity: false,
      sku: ""
    },
    data: []
  });
  const getData = () => {
    setLoading(true);
    axios.post("/api/dismag/query", {
      sku: DisMagSku,
      collection: DisMagCollection,
      commodity: DisMagCommodity,
      location: DisMagLocation,
      site: DisMagSite
    }).then(answer => {
      setPayload(answer.data["payload"].data);
      setLoaded(true);
      setLoading(false);
    }).catch(e => {
      console.error(e);
      setError(`${e}`);
      setLoading(false);
    });
    return loadingCircle;
  }
  const clearParams = () => {
    setDisMagSite(`${auth.appdata ? auth.appdata["ifs"]["defaults"]["site"] : ""}`);
    setDisMagLocation(`${auth.appdata ? auth.appdata["ifs"]["defaults"]["location"] : ""}`);
    setDisMagCollection(nowCollection);
    setDisMagCommodity(`${auth.appdata ? auth.appdata["ifs"]["defaults"]["commodity"] : ""}`);
    setDisMagSku("");
    setDisMagTiming(false);
    setDisMagQuantity(false);
  }
  const onSiteChange = (site: string) => {
    clearParams();
    setDisMagSite(site);
  }
  const title = <h4 style={{ textAlign: "center" }}>Warehouse availability</h4>
  const runQueryEnabled = sitesLoaded && paramsLoaded && DisMagSite && DisMagLocation;
  const params = <Container>
    {title}
    <SiteSelect
      current={DisMagSite}
      onSelect={onSiteChange}
      onLoaded={setSitesLoaded}
    />
    {DisMagSite ?
      <ParamSelect
        site={DisMagSite}
        sku={DisMagSku}
        location={DisMagLocation}
        collection={DisMagCollection}
        commodity={DisMagCommodity}
        timing={DisMagTiming}
        quantity={DisMagQuantity}
        onSKU={setDisMagSku}
        onCollection={setDisMagCollection}
        onLocation={setDisMagLocation}
        onCommodity={setDisMagCommodity}
        onTiming={setDisMagTiming}
        onQuantity={setDisMagQuantity}
        onLoaded={setParamsLoaded}
      /> :
      null}
    <div style={{ textAlign: 'center', marginTop: '24px' }}>
      <Button label="Run Query" onClick={() => { setShowResult(true) }} disabled={!runQueryEnabled} />
    </div>
  </Container>
  const [showResult, setShowResult] = React.useState(false);
  
  if (!(auth?.groups.includes(_ACL_LEVEL_) || auth?.groups.includes("G_D_ADMIN_ITALY"))) setError(`You are not allowed to access this feature! Level required: ${_ACL_LEVEL_}`);
  else if (error) return errorAlert;
  else if (showResult) {
    if (!loading && !loaded) return getData();
    else if (!loaded) return loadingCircle;
  } else {
    return params;
  }

  let DisMagCommodityText="";
  switch (DisMagCommodity) {
    case "*": DisMagCommodityText="All"; break;
    case "?": DisMagCommodityText="None"; break;
    case "@": DisMagCommodityText="Kit"; break;
    default: DisMagCommodityText=DisMagCommodity; break;
  }

  return <Container>
    {title}
    <p style={{textAlign: "center", marginTop: "-16px", fontSize: "small"}}>
      <i>Site: </i><b>{DisMagSite}</b>&nbsp;&nbsp;<i>Location: </i><b>{DisMagLocation}</b>
      {DisMagSku ? <span><br/><i>Sku: </i><b>{DisMagSku}</b>&nbsp;&nbsp;</span>: null}
      {<span><br/><i>Commodity: </i><b>{DisMagCommodityText}</b>&nbsp;&nbsp;</span>}
      {<span><i>Collection: </i><b>{DisMagCollection == "*" ? "All" : DisMagCollection}</b>&nbsp;&nbsp;</span>}
    </p>
    <DMDisplayGrid data={payload} />
    <div style={{ textAlign: 'center', marginTop: '24px' }}>
      <Button label="Back to Params" onClick={() => {
        //clearParams();
        setShowResult(false);
        setLoaded(false);
      }} disabled={!showResult || !loaded} />
    </div>
  </Container>
}

export default DisMag;